
export function validPhone(phone) {
  const reg = /^((\+)?86|((\+)?86)?)0?1[3456789]\d{9}$/
  // const reg = /^1[3|4|5|6|7|8][0-9]{9}$/
  return !reg.test(phone)
}

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function isSvg(path) {
  var reg = /\.(svg)$/
  return reg.test(path)
}

/**
 * @param {string} password
 * example Michelin123@
 * @returns {Boolean}
 */
export function validPassword(password) {
  var reg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{6,20}$/
  return reg.test(password)
}

export function validName(password) {
  // var reg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{0,20}$/
  var reg = /^[a-zA-Z0-9\u4e00-\u9fa5(){} -_./~]{2,20}$/
  return reg.test(password)
}
